// See: http://www.jacklmoore.com/notes/rounding-in-javascript/
function round(value, decimals) {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
}

function parseLocaleNumber(stringNumber, locale) {
  if (!stringNumber) return 0;
  const thousandSeparator = Intl.NumberFormat(locale).formatToParts(11111)[1].value;
  const decimalSeparator = Intl.NumberFormat(locale).formatToParts(1.1)[1].value;

  return parseFloat(stringNumber
    .replace(new RegExp("\\" + thousandSeparator, "g"), "")
    .replace(new RegExp("\\" + decimalSeparator), "."),
  );
}

function numericFilter(event) {
  event = event ? event : window.event;
  const key = (event && event.key) || "";

  // Allow modifier combos (Ctrl/Cmd) so user can do Ctrl+A/C/V, etc.
  if (event.ctrlKey || event.metaKey) return false;

  // Allow control/navigation keys (Backspace, Delete, Tab, Enter, Arrow keys, Home, End)
  if (key.length !== 1) return false;

  // Allow one dot only
  if (key === ".") {
    const input = event.target;
    if (input && input.value && input.value.includes(".")) {
      event.preventDefault();
      return false;
    }
    return false;
  }

  // Allow digits only
  if (!/^\d$/.test(key)) {
    event.preventDefault();
    return false;
  }

  return false;
}

function numericRoundFilter(event) {
  event = event ? event : window.event;
  const key = (event && event.key) || "";

  // Allow modifier combos (Ctrl/Cmd) so user can do Ctrl+A/C/V, etc.
  if (event.ctrlKey || event.metaKey) return false;

  // Allow control/navigation keys (Backspace, Delete, Tab, Enter, Arrow keys, Home, End)
  // These have key names longer than 1 character (e.g. "Backspace")
  if (key.length !== 1) return false;

  // Allow digits only (no decimals)
  if (!/^\d$/.test(key)) {
    event.preventDefault();
    return false;
  }

  return false;
}

function numericWithNegativeFilter(event) {
  event = event ? event : window.event;
  const expect = event.target.value.toString() + event.key.toString();
  return !/^\d?\-?\d*[.,]?\d*$/.test(expect) ? event.preventDefault() : false;
}

export default {
  round: function (value, decimals) {
    return round(value, decimals);
  },
  parseLocaleNumber: parseLocaleNumber,
  numericWithNegativeFilter: function (event) {
    return numericWithNegativeFilter(event);
  },
  numericFilter: numericFilter,
  numericRoundFilter: numericRoundFilter,
};
